import Add from '@mui/icons-material/Add';
import { CircularProgress, IconButton } from '@mui/material';
import PickMedia from '../../../../../../../../../../../components/FormInputs/PickMedia';
import { ALLOWED_MESSAGE_MIME_TYPES } from '../../../../../../../contexts/chatMessages.context.utilts';

const PICK_MEDIA_ID = 'chat-message-pick-media';

interface ChatMessagePickMediaButtonProps {
  isUploading: boolean;
  onPickMedia: (file: File[]) => void;
}

const ChatMessagePickMediaButton = ({
  onPickMedia,
  isUploading,
}: ChatMessagePickMediaButtonProps) => {
  const handleClick = () => {
    document.getElementById(PICK_MEDIA_ID)?.click();
  };

  return (
    <PickMedia
      multiple
      id={PICK_MEDIA_ID}
      onChange={onPickMedia}
      accept={ALLOWED_MESSAGE_MIME_TYPES.join(',')}
    >
      <IconButton onClick={handleClick} color="primary" size="small">
        {isUploading ? <CircularProgress size={20} /> : <Add fontSize="small" />}
      </IconButton>
    </PickMedia>
  );
};

export default ChatMessagePickMediaButton;
